module.exports = __webpack_public_path__ + "img/fa-regular-400.e75dfd90.svg";